import { Box, Skeleton, Stack, useTheme } from "@mui/material"
import { keyframes } from "@emotion/react"

const shimmer = keyframes`
  0% {
    background-position: -500px 0;
  }
  100% {
    background-position: 500px 0;
  }
`

const SharieSkeleton = ({ width = "100%", height = "auto" }) => {
  const theme = useTheme()

  const shimmerStyle = {
    backgroundImage: `linear-gradient(90deg, white 0%, ${theme.palette.primary.light} 50%, white 100%)`,
    backgroundSize: "1000px 100%",
    backgroundRepeat: "no-repeat",
    animation: `${shimmer} 2s infinite linear`,
    opacity: 0.1,
  }

  const skeletonOptions = [
    <Skeleton key='avatar' variant='circular' width={50} height={50} />,
    <Skeleton key='title1' variant='text' width='60%' height={30} />,
    <Skeleton key='line1' variant='text' width='90%' height={20} />,
    <Skeleton key='line2' variant='text' width='85%' height={20} />,
    <Skeleton key='line3' variant='text' width='70%' height={20} />,
    <Skeleton key='title2' variant='text' width='50%' height={30} />,
    <Skeleton key='line4' variant='text' width='95%' height={20} />,
    <Skeleton key='line5' variant='text' width='60%' height={20} />,
    <Skeleton key='line6' variant='text' width='80%' height={20} />,
  ]

  const getRandomSkeletons = () => {
    const shuffled = skeletonOptions.sort(() => 0.5 - Math.random())
    return shuffled.slice(0, 5)
  }

  return (
    <Box
      sx={{
        width,
        height,
        borderRadius: "0.8rem",
        backgroundColor: "background.paper",
        boxShadow: 3,
        p: 2,
        ...shimmerStyle,
      }}
    >
      <Stack spacing={2}>{getRandomSkeletons()}</Stack>
    </Box>
  )
}

export default SharieSkeleton
